<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1 v-if="showParent">
                <b-link :to="{name: 'crop-types.browse'}">&ldquo;{{ cropType.name }}&rdquo;</b-link>
                / Variety Groups
            </h1>
            <h1 v-else>
                {{ cropType.name }}
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog" v-if="canManage"
                   v-b-tooltip.left title="Add new variety group"><i class="zmdi zmdi-plus"></i>
                </a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Variety Groups
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>

            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">

                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Variety Group'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>

                    <b-button :to="{name:'varieties.browse', params: {varietyGroupId: row.item.id}}"
                              variant="info btn--icon" v-b-tooltip.hover="'View Varieties'">
                        <i class="zmdi zmdi-chevron-right"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" :cropType="cropType" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingVarietyGroup" v-if="editingVarietyGroup"
                   :varietyGroup="editingVarietyGroup" :cropType="cropType" />
    </div>
</template>

<script>
import findCropTypeQuery from '@views/VarietyGroups/Browse/queryFindCropType.graphql';
import listVarietyGroupsQuery from '@views/VarietyGroups/Browse/queryListVarietyGroups.graphql';

import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseVarietyGroups',
  props: {
    cropTypeId: {
      required: true,
    },
    canManage: true,
    showParent: true,
  },
  apollo: {
    cropType: {
      query: findCropTypeQuery,
      update: data => data.findCropType,
      variables() {
        return {
          input: {
            id: this.cropTypeId,
          },
        };
      },
    },
    varietyGroups: {
      query: listVarietyGroupsQuery,
      variables() {
        return {
          input: {
            crop_type_id: this.cropTypeId,
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.varietyGroups = data.filterVarietyGroups.data;
          this.pagination.total = data.filterVarietyGroups.meta.total;
        }
      },
    },
  },
  data() {
    return {
      varietyGroups: [],
      cropType: null,
      editingVarietyGroup: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Variety Group',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.varietyGroups || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(varietyGroup) {
      this.editingVarietyGroup = varietyGroup;
    },
    closeEditDialog() {
      this.editingVarietyGroup = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
